"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _system = require("@mui/system");

var CalendarContainer = (0, _system.styled)('div')(function (_ref) {
  var _theme$components;

  var theme = _ref.theme;
  return (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.Calendar;
});
var _default = CalendarContainer;
exports["default"] = _default;